<script>
import FacilitySelect from "@/views/orders/components/FacilitySelect.vue";
import { OrdersMixin } from "@/views/orders/orders.mixin";
import OmniDialog from "@/components/OmniDialog.vue";
import { customAlphabet } from "nanoid";
import OmniTextarea from "@/components/inputs/Textarea.vue";
import StopDateRange from "@/views/orders/components/StopDateRange.vue";
import { OrderStopState, OrderStopStatus, OrderStopTimeType, OrderStopType } from "@/data/order.ts";
import { useError } from "@/composables/useError.ts";

const { scrollToError } = useError();

export default {
  name: "AddReloadStopDialog",
  components: { StopDateRange, OmniTextarea, OmniDialog, FacilitySelect },
  mixins: [OrdersMixin],
  props: {
    modelValue: Boolean,
    tripStops: Array,
    position: Number,
  },
  emits: ["update:modelValue", "add"],
  data() {
    return {
      reloadStop: {
        facilityId: null,
        note: "",
        timeTo: null,
        timeFrom: null,
        timeType: OrderStopTimeType.appointment,
        timezone: null,
        type: OrderStopType.reload,
        address: null,
        orderStopId: null,
        state: OrderStopState.new,
        status: OrderStopStatus.notStarted,
        isReload: true,
        facility: null,
        id: this.generateId(),
      },
      loading: false,
    };
  },
  computed: {
    showDialog: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
  },
  watch: {
    showDialog: {
      handler(value) {
        if (!value) {
          this.facilityId = null;
          this.note = "";
        }
      },
    },
  },
  methods: {
    async loadFacility() {
      this.loading = true;
      try {
        const response = await this.$api.company.findFacilityById(this.reloadStop.facilityId);

        if (!response.data) {
          return;
        }

        this.reloadStop.facility = response.data;
        this.reloadStop.timezone = this.reloadStop.facility.timezone;
        this.reloadStop.address = this.reloadStop.facility.address;
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
    generateId() {
      const nanoid = customAlphabet("1234567890abcdef", 16);
      return nanoid();
    },
    async save() {
      const validResult = await this.$refs.form.validate();

      if (!validResult.valid) {
        scrollToError();
        return;
      }

      this.$emit("add", this.reloadStop);
    },
  },
};
</script>
<template>
  <omni-dialog
    v-model="showDialog"
    :loading="loading"
    primary-action-label="Add"
    title="Add reload stop"
    width="830"
    @primary-action:click="save"
  >
    <v-form ref="form" class="py-4">
      <facility-select v-model="reloadStop.facilityId" class="mb-3" editable @update:model-value="loadFacility" />

      <omni-textarea
        v-model="reloadStop.note"
        :label="$t('trip.reload-stop-note')"
        class="mt-6"
        rows="3"
      ></omni-textarea>

      <div class="font-size-16 text-grey-darken-3 font-weight-500 mt-6">{{ $t("general.time") }}</div>

      <div class="mt-4">
        <stop-date-range v-model="reloadStop" hide2-time-frame />
      </div>
    </v-form>
  </omni-dialog>
</template>
